<div id="magicwin_container" class="lotto-iframe"></div>